import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "snackbar-container" }
const _hoisted_2 = {
  key: 0,
  class: "snackbar"
}
const _hoisted_3 = { class: "snackbar-text medium-text-white" }
const _hoisted_4 = { class: "snackbar-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "snackbarToggle" }, {
      default: _withCtx(() => [
        (_ctx.showSnackbar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "action-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSnackBar && _ctx.closeSnackBar(...args)))
                }, _toDisplayString(_ctx.buttonActionText), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}